module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageBody"
  }, [_c('div', {
    staticClass: "pageScroll"
  }, [_c('section', {
    staticClass: "banner cow"
  }, [_c('div', {
    staticClass: "productBanner fwc",
    style: ({
      background: 'url(' + require('../../assets/images/' + _vm.imgUrl) + ') no-repeat scroll center center / cover'
    })
  })]), _vm._v(" "), _c('section', {
    staticClass: "cow fwc routeBox"
  }, [_c('section', {
    staticClass: "cow fws routeDiv",
    staticStyle: {
      "width": "1200px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c33.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("您的位置：")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "span",
      "to": {
        name: 'home',
        query: {}
      },
      "replace": ""
    }
  }, [_vm._v("主页")]), _vm._v(" "), _c('p', [_vm._v(">")]), _vm._v(" "), _c('span', [_vm._v("案例分析")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cow productAll fwc"
  }, [_c('div', {
    staticClass: "productDiv",
    staticStyle: {
      "margin-bottom": "106px"
    }
  }, [(_vm.caseType > 5) ? _c('ul', {
    staticClass: "cow productTab fwf"
  }, _vm._l((_vm.caseType), function(item, index) {
    return _c('li', {
      key: index,
      class: ['productLi2', {
        caseTabActive: _vm.tabIndex == index
      }],
      attrs: {
        "index": index
      },
      on: {
        "click": function($event) {
          return _vm.changeTab(item.id, index)
        }
      }
    }, [_vm._v(_vm._s(item.caseTypeName))])
  }), 0) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "cow ptUl ptUl2 fsc"
  }, [_vm._l((_vm.caseData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "ptLi",
      attrs: {
        "index": index
      },
      on: {
        "click": function($event) {
          return _vm.goChild(item.id, index)
        }
      }
    }, [_c('img', {
      staticClass: "ptimg",
      attrs: {
        "src": _vm.$fileUrl + item.cover
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v("了解更多>")])])
  }), _vm._v(" "), _c('i', {
    staticClass: "ci"
  }), _vm._v(" "), _c('i', {
    staticClass: "ci"
  }), _vm._v(" "), _c('i', {
    staticClass: "ci"
  }), _vm._v(" "), _c('i', {
    staticClass: "ci"
  }), _vm._v(" "), _c('i', {
    staticClass: "ci"
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.caseData.length > 0),
      expression: "caseData.length>0"
    }],
    staticClass: "cow fwe"
  }, [_c('div', {
    staticClass: "pager clearfix",
    staticStyle: {
      "margin-right": "58px"
    },
    attrs: {
      "id": "pager"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.caseData.length > 0),
      expression: "!caseData.length>0"
    }],
    staticClass: "cow fhc kong"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/kong.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无更多")])])])]), _vm._v(" "), _c('v-footer', {
    attrs: {
      "tabActiveIndex": 0
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c4e90e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/case/case.vue
// module id = 374
// module chunks = 8